/**
 * Transform boats data to equipment format
 * @param {Array} boats - Array of boat objects
 * @returns {Array} Transformed equipment array
 */
export const transformBoatsToEquipment = (boats) => {
  return boats.map((boat) => ({
    ...boat,
    id: boat.id,
    name: boat.equipment_title,
    quantity: boat.quantity,
    category: boat.category,
    status: boat.status,
    is_active: boat.status === "active"
  }))
}

/**
 * Filter experiences by selected IDs
 * @param {Array} experiences - Array of experience objects
 * @param {Array} selectedIds - Array of selected experience IDs
 * @returns {Array} Filtered experiences
 */
export const filterSelectedExperiences = (experiences, selectedIds) => {
  if (!selectedIds.length) return []
  return experiences.filter((exp) => selectedIds.includes(String(exp.id)))
}
